import {
  HISTORY_LIST_REQUEST,
  HISTORY_LIST_SUCCESS,
  HISTORY_LIST_FAIL,
} from "../../constants/patientConstants/historyConstants.js";

const initialState = { history: [] };

export const historyReducer = (state = initialState, action) => {
  switch (action.type) {
    case HISTORY_LIST_REQUEST:
      return { ...state, loading: true };
    case HISTORY_LIST_SUCCESS:
      return { loading: false, history: action.payload };
    case HISTORY_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
